import {useTestingActionsQuery} from './useTestingActionsQuery';
import {useTestingActionsSearch} from './useTestingActionsSearch';
import {useTestingActionsTableColumns} from './useTestingActionsTableColumns';
import {useApplicationNameResolver} from '../../testing-api-integration/hooks/useApplicationOptions';

export const useTestingActions = (filters: Record<string, string> = {}) => {
    const {
        data: items = [],
        isLoading: loading
    } = useTestingActionsQuery(filters);
    const {keyword} = useTestingActionsSearch();
    const {columns} = useTestingActionsTableColumns();
    const applicationNameFor = useApplicationNameResolver();

    // Client-side keyword filtering. `keyword` comes from the module-scoped store
    // in useTestingActionsSearchQuery, so the value typed into the table toolbar
    // in a sibling component actually reaches this filter (FNP-815).
    const needle = keyword.trim()
                          .toLowerCase();

    const visibleItems = items.filter(item =>
        !needle ||
        item.actionCode?.toLowerCase()
            .includes(needle) ||
        item.name?.toLowerCase()
            .includes(needle) ||
        // Matches the application NAME shown in the column, not the raw
        // `applicationId` — the id is an opaque uuid the operator never sees, so
        // matching on it alone would make the column look unsearchable. The id
        // still matches as a fallback for a dangling reference, which is
        // exactly the case where the id IS what is on screen.
        applicationNameFor(item.applicationId)?.toLowerCase()
            .includes(needle) ||
        item.applicationId?.toLowerCase()
            .includes(needle) ||
        item.status?.toLowerCase()
            .includes(needle)
    );

    return {
        items,
        visibleItems,
        loading,
        columns,
    };
};
